'use client';

import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["tabs", "title", "titleAs", "titleVariant", "link", "dropdownLeft", "contentMaxWidth", "dropdownRight", "resultCount", "selectedValue", "inputValue", "setInputValue", "onSearchChange", "onSubmit", "onRemoveTag", "clearAllOnClick", "clearAllLabel", "showResultsLabel", "navBarOnClick", "inputPlaceholder", "searchInputLabel", "searchButtonLabel", "searchButtonDisabled", "searchButtonOnClick", "searchTags", "searchTagRemoveActionLabel", "popOver", "formInputOnFocus", "autoComplete"];
import React, { useState } from 'react';
import { FormInputDropdown } from "../FormInputDropdown/index.mjs";
import { Container, Content, InputContainer, PillWrapper, ResultCountWrapper, SearchButton, SearchPill, TitleWrapper } from "./index.styled.mjs";
import { ButtonSecondary } from "../../../core/components/ButtonSecondary/index.mjs";
import { FormInput } from "../../../core/components/FormInput/index.mjs";
import { FormInputIcon } from "../../../core/components/FormInputIcon/index.mjs";
import { IconArrowTopRight } from "../../../core/components/Icon/icons/IconArrowTopRight/index.mjs";
import { IconSearch } from "../../../core/components/Icon/icons/IconSearch/index.mjs";
import { NavBarList } from "../../../core/components/NavBarList/index.mjs";
import { NavBarListItem } from "../../../core/components/NavBarListItem/index.mjs";
import { TextLink } from "../../../core/components/TextLink/index.mjs";
import { Type } from "../../../core/components/Type/index.mjs";
import { cssSpacing } from "../../../core/index.mjs";
import { newRequiredPropWarning } from "../../../core/logging.mjs";
export var SearchModule = function SearchModule(_ref) {
  var tabs = _ref.tabs,
    title = _ref.title,
    titleAs = _ref.titleAs,
    titleVariant = _ref.titleVariant,
    link = _ref.link,
    dropdownLeft = _ref.dropdownLeft,
    contentMaxWidth = _ref.contentMaxWidth,
    dropdownRight = _ref.dropdownRight,
    resultCount = _ref.resultCount,
    selectedValue = _ref.selectedValue,
    inputValue = _ref.inputValue,
    setInputValue = _ref.setInputValue,
    _ref$onSearchChange = _ref.onSearchChange,
    onSearchChange = _ref$onSearchChange === void 0 ? setInputValue : _ref$onSearchChange,
    onSubmit = _ref.onSubmit,
    onRemoveTag = _ref.onRemoveTag,
    clearAllOnClick = _ref.clearAllOnClick,
    clearAllLabelOriginal = _ref.clearAllLabel,
    showResultsLabelOriginal = _ref.showResultsLabel,
    navBarOnClick = _ref.navBarOnClick,
    inputPlaceholder = _ref.inputPlaceholder,
    searchInputLabel = _ref.searchInputLabel,
    searchButtonLabel = _ref.searchButtonLabel,
    _ref$searchButtonDisa = _ref.searchButtonDisabled,
    searchButtonDisabled = _ref$searchButtonDisa === void 0 ? false : _ref$searchButtonDisa,
    searchButtonOnClick = _ref.searchButtonOnClick,
    searchTags = _ref.searchTags,
    searchTagRemoveActionLabel = _ref.searchTagRemoveActionLabel,
    popOver = _ref.popOver,
    formInputOnFocus = _ref.formInputOnFocus,
    _ref$autoComplete = _ref.autoComplete,
    autoComplete = _ref$autoComplete === void 0 ? 'on' : _ref$autoComplete,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(tabs ? tabs[0] : null),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var clearAllLabel = clearAllLabelOriginal;
  if (!clearAllLabelOriginal && !!clearAllOnClick) {
    newRequiredPropWarning('SearchModule', 'clearAllLabel', 'Prop for the button to clear all selections');
    clearAllLabel = 'Clear all';
  }
  var showResultsLabel = showResultsLabelOriginal;
  if ((showResultsLabelOriginal === null || showResultsLabelOriginal === void 0 ? void 0 : showResultsLabelOriginal.length) === 0) {
    if (resultCount && resultCount > -1) {
      showResultsLabel = "Showing ".concat(resultCount, " results").concat(!!selectedValue ? " for ".concat(selectedValue) : '');
    } else {
      showResultsLabel = '';
    }
  }
  var handleInputKeyPress = function handleInputKeyPress(e) {
    if (e.key === 'Enter') {
      onSubmit === null || onSubmit === void 0 || onSubmit();
    }
  };
  var handleInputChange = function handleInputChange(e) {
    onSearchChange === null || onSearchChange === void 0 || onSearchChange(e.target.value);
  };
  var handleTabClick = function handleTabClick(tab) {
    if (navBarOnClick) {
      navBarOnClick(tab);
    }
    setActiveTab(tab);
  };
  var handleFormInputOnFocus = function handleFormInputOnFocus() {
    if (formInputOnFocus) {
      formInputOnFocus();
    }
  };
  return /*#__PURE__*/React.createElement(Container, props, /*#__PURE__*/React.createElement(Content, {
    style: {
      maxWidth: contentMaxWidth
    }
  }, tabs && /*#__PURE__*/React.createElement(NavBarList, null, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement(NavBarListItem, {
      key: tab.label,
      active: activeTab === tab,
      onClick: function onClick() {
        return handleTabClick(tab);
      },
      label: tab.label,
      href: tab.href,
      sentenceCase: true
    });
  })), /*#__PURE__*/React.createElement(TitleWrapper, null, title && /*#__PURE__*/React.createElement(Type, {
    as: titleAs,
    variant: titleVariant || 'celloCanon'
  }, title), link && /*#__PURE__*/React.createElement(TextLink, {
    semanticColor: "textBrightAccent",
    href: link.href,
    standalone: true
  }, link.label, ' ', /*#__PURE__*/React.createElement(IconArrowTopRight, {
    size: "small",
    style: {
      marginLeft: cssSpacing('tighter-4', '4px')
    }
  }))), /*#__PURE__*/React.createElement(FormInputDropdown, {
    dropdownLeft: dropdownLeft,
    dropdownRight: dropdownRight,
    button: searchButtonLabel && /*#__PURE__*/React.createElement("span", {
      style: {
        alignSelf: 'flex-start'
      }
    }, /*#__PURE__*/React.createElement(SearchButton, {
      disabled: searchButtonDisabled,
      onClick: function onClick() {
        return onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
      }
    }, searchButtonLabel))
  }, /*#__PURE__*/React.createElement(InputContainer, {
    label: inputPlaceholder,
    hideLabel: true,
    labelFor: "searchmodule-search-input"
  }, /*#__PURE__*/React.createElement(FormInputIcon, {
    iconLeading: /*#__PURE__*/React.createElement(IconSearch, null)
  }, /*#__PURE__*/React.createElement(FormInput, {
    "aria-label": inputPlaceholder ? undefined : searchInputLabel,
    id: "searchmodule-search-input",
    onChange: handleInputChange,
    onFocus: function onFocus() {
      return handleFormInputOnFocus();
    },
    value: inputValue,
    onKeyPress: handleInputKeyPress,
    type: "text",
    placeholder: inputPlaceholder,
    autoComplete: autoComplete
  })))), popOver, (!!resultCount || resultCount !== undefined && selectedValue && (searchTags === null || searchTags === void 0 ? void 0 : searchTags.length)) && /*#__PURE__*/React.createElement(ResultCountWrapper, null, /*#__PURE__*/React.createElement(Type, {
    as: "p",
    variant: "ballad"
  }, showResultsLabel), clearAllOnClick && /*#__PURE__*/React.createElement(ButtonSecondary, {
    onClick: clearAllOnClick,
    size: "small"
  }, clearAllLabel)), !!(searchTags !== null && searchTags !== void 0 && searchTags.length) && /*#__PURE__*/React.createElement(PillWrapper, null, searchTags.map(function (tag, i) {
    return /*#__PURE__*/React.createElement(SearchPill, {
      key: tag,
      onClickRemove: function onClickRemove() {
        return onRemoveTag === null || onRemoveTag === void 0 ? void 0 : onRemoveTag(i);
      },
      removeLabel: searchTagRemoveActionLabel || ''
    }, tag);
  }))));
};